import { render, staticRenderFns } from "./AdminMetaFieldsEdit.vue?vue&type=template&id=18d8f31e&scoped=true&"
import script from "./AdminMetaFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./AdminMetaFieldsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8f31e",
  null
  
)

export default component.exports